import { metaData, registerImageLoader } from '@cornerstonejs/core';
import { logging, registerDefaultProviders } from '@cornerstonejs/metadata';
import { loadImage, loadImageFromNaturalizedMetadata } from './loadImage.js';
import { metaDataProvider } from './metaData/index.js';
const log = logging.loaderLog.getLogger('wadouri');
export default function (options) {
    if (options?.useLegacyMetadataProvider === true) {
        log.warn('wadouri metaDataProvider is deprecated. Use registerMetadataProvider module from @cornerstonejs/metadata instead.');
        registerImageLoader('dicomweb', loadImage);
        registerImageLoader('wadouri', loadImage);
        registerImageLoader('dicomfile', loadImage);
        metaData.addProvider(metaDataProvider);
        return;
    }
    registerImageLoader('dicomweb', loadImageFromNaturalizedMetadata);
    registerImageLoader('wadouri', loadImageFromNaturalizedMetadata);
    registerImageLoader('dicomfile', loadImageFromNaturalizedMetadata);
    registerDefaultProviders();
}
export { loadImageFromNaturalizedMetadata as loadImage } from './loadImage.js';
